import {uri} from '@/api/uri/base'
import Toast from '@/utils/toast'
import {calPrice} from '@/utils/calc.js'
import {
  getRequest,
  postJsonRequest,
  putJsonRequest,
  deleteRequest,
} from '@/utils/api'

/*
*   分页获取公告配置列表
* */
export function getNoticeList() {
  let params = {
    isOnline: 1
  }
  return new Promise((resolve, reject) => {
    getRequest(uri.notice.getPageList, params).then(resp => {
      resolve(resp.data)
    }).catch(error => {
      // Toast.show({
      //   message: error || '查询公告配置列表失败',
      //   type: 'error'
      // })
      reject(error)
    })
  })
}


/**
 * 添加公告配置
 * @param  title  "标题"
 * @param  imgKey  "图片"
 * @param  isTop  "是否重新发布"
 * @param  visibleUserType  "公告渠道"
 * @param  content  "公告内容"
 * @param  description  "描述"
 */

export function addNotice(
  {
    title ,
    isTop ,
    visibleUserType ,
    content,
    isOnline
}) {
  return new Promise((resolve, reject) => {
    if (!title  || !visibleUserType || !content || !isOnline  ) {
      reject("错误参数："+ "title="+title  + "visibleUserType="+visibleUserType  + "content="+content + "content="+content)
    }
    let params = {
      title ,
      visibleUserType ,
      content ,
      isTop,
      isOnline
    }
    postJsonRequest(uri.notice.add, params).then(resp => {
      Toast.show({
        message: '添加公告配置成功',
        type: 'success'
      })
      resolve(resp.data)
    }).catch(error => {
      Toast.show({
        message: error || '添加公告配置信息失败',
        type: 'error'
      })
      reject(error)
    })
  })
}

/**
 * 更改公告配置信息
 *
 * @param   noticeid
 * @param  title  "标题"
 * @param  imgKey  "图片"
 * @param  isTop  "是否重新发布"
 * @param  visibleUserType  "可见对象"
 * @param  content  "公告内容"
 * @param  description  "描述"
 */
export function updateNotice(noticeId, {
  title ,
  isTop ,
  visibleUserType ,
  content ,
  isOnline
}) {
  return new Promise((resolve, reject) => {
    if (  !title  ||  !visibleUserType ||  !content || !isOnline ) {
      reject("错误参数："+ + "title="+title   + "visibleUserType="+visibleUserType  + "content="+content + 'isOnline' +isOnline )
    }
    let params = {
      id: noticeId,
      title,
      isTop,
      visibleUserType,
      content,
      isOnline
    }
    putJsonRequest(uri.notice.update, params).then(resp => {
      Toast.show({
        message: '更新公告配置成功',
        type: 'success'
      })
      resolve(resp.data)
    }).catch(error => {
      Toast.show({
        message: error || '添加公告配置信息失败',
        type: 'error'
      })
      reject(error)
    })
  })
}


/**
 *  删除公告配置信息
 * @param noticeIdString   字符串 用逗号隔开
 */
export function deleteNotice(noticeIdString) {
  return new Promise((resolve, reject) => {
    if (!noticeIdString) {
      reject("错误参数：noticeIdString="+noticeIdString+"")
    }
    deleteRequest(uri.notice.delete + '/' + noticeIdString).then(resp => {
      resolve(resp.data)
    }).catch(error => {
      Toast.show({
        message: error || '删除公告配置失败',
        type: 'error'
      })
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/base/notice.js